<template>
  <detail-layout>
    <template slot="header">
      <base-header icon="user" :content="header" />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form :model="form" :rules="isCreate ? newRules : updateRules" ref="ruleForm" class="flex flex-row w-full"
          autocomplete="off">
          <div class="flex-1 hideHScroll">

            <base-collapsible-form ref="baseCollapsibleConfigGeneral"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.client_data') }}</h4>
              </template>
              <template slot="content">

                <div class="lg:mb-2" v-if="role === 3">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('distributors.entity_name') }}</label>
                  <el-form-item prop="idDistribuidor">
                    <base-el-select class="w-full" :options="distribuidores" v-model="form.idDistribuidor" clearable filterable
                      :loading="loadingDistribuidores" :disabled="!isCreate" />
                  </el-form-item>
                </div>

                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                      $t('app.name') }}</label>
                    <el-form-item prop="name">
                      <el-input clearable class="w-full" v-model="form.name" maxlength='500' />
                    </el-form-item>
                  </div>
                </div>
                <div class="lg:mb-2">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.cod_ext') }}</label>
                    <el-form-item prop="codigoExterno">
                      <el-input clearable class="w-full" v-model="form.codigoExterno" maxlength='20' />
                    </el-form-item>
                  </div>
                </div>
                <div class="lg:mb-2" v-if="!isCreate">
                  <div class="mandatory">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon
                        v-if="isCreate" />{{ $t('app.serial_number') }}</label>
                    <el-form-item prop="ns">
                      <el-input :disabled="!isCreate" clearable class="w-full" v-model="form.ns" maxlength='50' />
                    </el-form-item>
                  </div>
                </div>
                <div class="lg:mb-2" v-if="!form.idDistribuidor">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon
                      v-if="isCreate" />{{ $t('clients.partner') }}</label>
                  <el-form-item prop="partnerId">
                    <base-el-select class="w-full" :options="partners" v-model="form.partnerId" :disabled="!isCreate" clearable filterable
                      allow-create :maxlength='50' :placeholder="$t('clients.partner_placholder_long')" />
                  </el-form-item>
                </div>

                <div class="lg:mb-2" v-if="!form.idDistribuidor">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">
                    <base-obligatory-icon v-if="isCreate" />{{ $t('clients.grupo_cliente') }}
                  </label>
                  <el-form-item prop="grupoClienteId">
                    <base-el-select class="w-full" :options="gruposCliente" v-model="form.grupoClienteId" clearable filterable
                      :loading="loadingGruposCliente" :disabled="!isCreate" />
                  </el-form-item>
                </div>

                <div class="lg:mb-2" v-if="!isCreate">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon
                      v-if="isCreate" />{{ $t('clients.service_type') }}</label>
                  <el-form-item prop="tipoServicio">
                    <base-el-select class="w-full" :options="tiposServicio" v-model="form.tipoServicio" clearable filterable disabled />
                  </el-form-item>
                </div>

                <div class="lg:mb-2" v-if="!isCreate">
                  <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.fecha_alta')}}</label>
                  <el-form-item prop="FechaAlta">
                    <el-date-picker class="bg-white dark:bg-darkblue-900" :disabled="role !== 3"
                      v-model="form.FechaAlta" type="date" :picker-options="dateRangeOptions"
                      :format="datePattern" value-format="yyyy-MM-dd[T]HH:mm:ss" placeholder="">
                    </el-date-picker>
                  </el-form-item>
                </div>

                <div class="mb-4">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.status') }}</label>
                  <el-switch :disabled="disableTipoLibre" class="switch-text break-normal both-switch" v-model="form.activo"
                    :active-text="$t('app.active')" />
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleLicenciamiento"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('license.header_long') }}</h4>
              </template>
              <template slot="content">

                <div class="lg:mb-0">
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                        $t('license.num_invoices') }}</label>
                      <el-form-item prop="NumInvoicesTotal">
                        <el-input 
                          :disabled="disableLicenciamiento" 
                          clearable 
                          class="w-full"
                          v-model.number="form.NumInvoicesTotal" 
                          :maxlength="validation.NumInvoicesTotal" />
                      </el-form-item>
                    </div>
                    <div class="px-2 w-full lg:mb-0" v-if="role === 3">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                        $t('license.num_volumen_invoices') }}</label>
                      <el-form-item prop="NumVolumenTotal">
                        <el-input 
                          :disabled="disableLicenciamiento" 
                          clearable 
                          class="w-full"
                          v-model.number="form.NumVolumenTotal" 
                          :maxlength="validation.NumVolumenTotal" />
                      </el-form-item>
                    </div>
                  </div>
                </div>

                <div class="lg:mb-0">
                  <div class="flex -mx-2 flex-col lg:flex-row">
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                        $t('license.stored_space') }}</label>
                      <el-form-item prop="StoredSpaceTotal">
                        <el-input 
                          :disabled="disableLicenciamiento" 
                          clearable 
                          class="w-full"
                          v-model.number="form.StoredSpaceTotal" 
                          :maxlength="validation.StoredSpaceTotal">
                          <template slot="append">MB</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                        $t('license.num_companies') }}</label>
                      <el-form-item prop="NumCompaniesTotal">
                        <el-input 
                          :disabled="disableLicenciamiento" 
                          clearable 
                          class="w-full"
                          v-model.number="form.NumCompaniesTotal" 
                          :maxlength="validation.NumCompaniesTotal" />
                      </el-form-item>
                    </div>
                    <div class="px-2 w-full lg:mb-0">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                        $t('license.num_users') }}</label>
                      <el-form-item rop="NumUsersTotal">
                        <el-input 
                          :disabled="disableLicenciamiento" 
                          clearable 
                          class="w-full"
                          v-model.number="form.NumUsersTotal" 
                          :maxlength="validation.NumUsersTotal" />
                      </el-form-item>
                    </div>
                  </div>
                </div>

                <div v-if="!isCreate">
                  <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('license.num_invoices') }}</label>
                    <div class="flex flex-row mt-2">
                      <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumInvoices, 'integer') }} / {{ $n(form.NumInvoicesTotalProgres, 'integer') }}</span>
                      <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumInvoices" :color="customColorMethod"></el-progress>
                    </div>
                  </div>
                  <div class="mb-4" v-if="role === 3">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('license.num_volumen_invoices') }}</label>
                    <div class="flex flex-row mt-2">
                      <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumVolumen, 'decimal') }} / {{ $n(form.NumVolumenTotalProgres, 'decimal') }}</span>
                      <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumVolumen" :color="customColorMethod"></el-progress>
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('license.stored_invoices') }}</label>
                    <div class="flex flex-row mt-2">
                      <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.StoredSpace, 'integer') }} / {{ $n(form.StoredSpaceTotalProgres, 'integer') }}</span>
                      <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageStoredSpace" :color="customColorMethod"></el-progress>
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_companies')}}</label>
                    <div class="flex flex-row mt-2">
                      <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumCompanies, 'integer') }} / {{ $n(form.NumCompaniesTotalProgres, 'integer') }}</span>
                      <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumCompanies" :color="customColorMethod"></el-progress>
                    </div>
                  </div>
                  <div class="mb-4">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('license.num_users')}}</label>
                    <div class="flex flex-row mt-2">
                      <span class="w-48 text-sm text-secondary-600 dark:text-darkblue-200">{{ $n(form.NumUsers, 'integer') }} / {{ $n(form.NumUsersTotalProgres, 'integer') }}</span>
                      <el-progress class="w-full dark:text-darkblue-200" :percentage="percentageNumUsers" :color="customColorMethod"></el-progress>
                    </div>
                  </div>
                </div>

                <div class="mb-4" v-if="!isCreate && form.FechaFacturacion">
                  <base-ro-input-minimal :label="$t('clients.alta_fact')" :data="$d(form.FechaFacturacion, 'numeric_datetime', { date: '-', datetime: ' ' })"/>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleFacturas"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.factura_submenu.header') }}</h4>
              </template>
              <template slot="content">
                <div class="mb-6">
                  <el-switch class="switch-text break-normal" v-model="form.PagarAlContabilizar"
                    :active-text="$t('clients.factura_submenu.auto_paid_long')"></el-switch>
                </div>
                <div class="mb-6" v-if="!isCreate && hasApprobationFlow">
                  <el-switch class="switch-text break-normal" v-model="form.FlujoAprobacion"
                    :active-text="$t('clients.factura_submenu.active_approbation_flow')"></el-switch>
                </div>
              </template>
            </base-collapsible-form>

            <base-collapsible-form ref="baseCollapsibleAutofactura"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2"
              v-if="!isCreate && hasAutofactura" >
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.autofactura_submenu.header') }}</h4>
              </template>
              <template slot="content">
              
                <div class="mb-6">
                  <el-switch class="switch-text break-normal" v-model="form.GenerarUsuarioAuto"
                    :active-text="$t('clients.autofactura_submenu.generate_provider_user')"></el-switch>
                </div>                
                <div class="mb-6">
                  <el-switch class="switch-text break-normal" v-model="form.EnviarMailFactura"
                    :active-text="$t('clients.autofactura_submenu.default_send_email_provider')"></el-switch>
                </div>
                <div class="mb-6">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.autofactura_submenu.default_user_provider_email') }}</label>
                  <el-form-item prop="EmailAutofacturaDefecto">
                    <el-input 
                      clearable 
                      class="w-full"
                      v-model="form.EmailAutofacturaDefecto" 
                      :maxlength="validation.MaxCharEmailProvider" />
                  </el-form-item>
                </div>
              </template>


            </base-collapsible-form>

            <div ref="baseConfigUsers">
              <div>
                <base-collapsible-form ref="baseCollapsibleConfigUsers"
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                  <template slot="headerRight">
                    <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.users_submenu.header') }}</h4>
                  </template>
                  <template slot="content">

                    <div class="mb-4">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{
                        $t('clients.users_submenu.config_link_user_pool') }}</label>
                      <el-switch class="switch-text break-normal both-switch" v-model="form.VincularUsuariosGrupoGestorInvoiZE"
                        :active-text="$t('app.active')" />
                    </div>

                    <label v-if="(hasAADIntegration || hasSAML2Integration)" class="text-sm font-semibold text-secondary-600 block mb-1">{{  $t('clients.users_submenu.config_local') }} </label>
                    <div class="lg:mb-2">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{
                        $t('clients.users_submenu.mesesUserPass') }}</label>
                      <el-form-item prop="mesesUserPass">
                        <base-el-select class="w-full" :options="mesesUserPassCaduc" v-model="form.mesesUserPass" clearable filterable />
                      </el-form-item>
                    </div>
                    <div class="lg:mb-2">
                      <div class="flex flex-col lg:flex-row lg:space-x-4 mb-6">
                        <div class="flex flex-row items-center mb-4 lg:mb-0">
                          <el-switch class="switch-text break-normal" v-model="form.RequiereOTP"
                            :active-text="$t('clients.users_submenu.otp')"></el-switch>
                          <!-- <base-tooltip-icon size="sm" :content="tooltipLocalAuth" class="ml-1"/> -->
                        </div>
                        <div class="flex flex-row items-center mb-4 lg:mb-0">
                          <el-switch class="switch-text break-normal" v-model="form.CambioPassPrimerAcceso"
                            :active-text="$t('clients.users_submenu.first_access')"></el-switch>
                          <!-- <base-tooltip-icon size="sm" :content="tooltipLocalAuth" class="ml-1"/> -->
                        </div>
                      </div>
                    </div>
                  </template>
                </base-collapsible-form>
              </div>
              <div v-if="isCreate">
                <base-collapsible-form ref="baseCollapsibleConfigUserInitial"
                  class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                  <template slot="headerRight">
                    <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.users_submenu.initial_header') }}
                    </h4>
                  </template>
                  <template slot="content">
                    <div class="lg:mb-2">
                      <div class="mandatory">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('users.entity_name') }}</label>
                        <el-form-item prop="username">
                          <el-input :disabled="!isCreate" clearable class="w-full" v-model="form.username"
                            maxlength='50' />
                        </el-form-item>
                      </div>
                    </div>
                    <div class="lg:mb-2">
                      <div class="mandatory">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $tc('users.email', 1) }}</label>
                        <el-form-item prop="email">
                          <el-input :disabled="!isCreate" clearable class="w-full" v-model="form.email" maxlength='255' />
                        </el-form-item>
                      </div>
                    </div>
                    <div class="lg:mb-2">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('app.language') }}</label>
                      <el-form-item prop="idioma">
                        <base-el-select class="w-full" :options="tiposIdioma" v-model="form.idioma" />
                      </el-form-item>
                    </div>
                    <div class="mb-6">
                      <!-- <div class="flex flex-row"> -->
                      <div class="flex flex-col lg:flex-row lg:space-x-4">
                        <div class="flex flex-row items-center mb-4 lg:mb-0">
                          <el-switch class="switch-text break-normal" v-model="form.verTodoStatuses"
                            :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                          <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1" />
                        </div>
                        <div class="flex flex-row items-center mb-4 lg:mb-0">
                          <el-switch class="switch-text break-normal" v-model="form.verTodoCompanies"
                            :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                          <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1" />
                        </div>
                      </div>
                    </div>
                    <div class="lg:mb-4">
                      <div class="lg:mb-2">
                        <base-password-form-item v-model="form.password" autocomplete="new-password" />
                        <base-password-form-item v-model="form.repeat_password" :password="form.password" autocomplete="new-password" repeat />
                      </div>
                    </div>
                  </template>
                </base-collapsible-form>
              </div>
            </div>

            <div v-if="!isCreate">
             <base-collapsible-form 
              ref="baseCollapsibleWhiteMetadata" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_metadatas')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :content="$t('tooltip.client.contentTooltipMetadataList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                 <el-table
                  ref="whitelistmetadata"
                  :data="form.ListaBlancaMetadatos"
                  style="width: 100%"
                  :empty-text="$t('app.no_data_text')"
                  max-height="250">
                  <el-table-column
                    prop="Nombre"
                    :label="$t('app.name')"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Tipo"
                    :label="$t('app.type')"
                    show-overflow-tooltip
                    width="150"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="120"
                    align="center"
                    :label="$tc('app.actions', 2)">
                    <template slot-scope="scope">
                    <div class="flex flex-row justify-end">
                      <base-button-icon 
                        v-if="scope.row.EsLista"
                        @click="addValueToListMetadataToggleDialog(scope)" name="editpencil" mode="core" size="xs" />
                      <base-button-icon @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core" size="xs" />
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('invoices.metadatos.new_metadato')"
                    @click="newMetadatoToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                  />
                </div>
                </template>
              </base-collapsible-form>
            </div>

            <base-collapsible-form ref="baseCollapsibleUsuarioServicio"
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
              <template slot="headerRight">
                <h4 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{ $t('clients.user_service_submenu.header') }}</h4>
              </template>
              <template slot="content">
                <!-- #region Activación -->
                <div class="mb-6 flex justify-between" v-if="isCreate || (!isCreate && !form.UsuarioServicio)">
                  <el-switch class="switch-text break-normal" v-model="form.serviceUser"
                    :active-text="$t('clients.user_service_submenu.active_service_user')"></el-switch>
                  <el-switch v-if="role === 3 && ((isServiceUserActive && isCreate) || (!isCreate && !form.UsuarioServicio && isServiceUserActive))" class="switch-text break-normal" v-model="form.generateApiKey"
                  :inactive-text="$t('clients.api_keys.user_pass')"
                  :active-text="$t('clients.api_keys.header')"></el-switch>
                </div>
                <!-- #endregion -->

                <!-- #region Visualización -->
                <div v-if="!isCreate && form.UsuarioServicio" class="mb-4">
                  <div class="mb-4">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('users.entity_name')
                      }}</label>
                      <el-form-item prop="UsuarioServicio">
                        <el-input disabled class="w-full" v-model="form.UsuarioServicio" maxlength='50' />
                      </el-form-item>
                    </div>
                    <div>
                      <div class="px-2 w-full lg:mb-0 mb-2">
                        <base-button mode="primary" :text="$t('clients.user_service_submenu.establecer_password')"
                          @click.prevent.stop="toggleDialogs" :loading="isGeneralLoading" />
                      </div>
                    </div>
                  </div>
                  <div v-if="role === 3" class="lg:mb-4 my-8" >
                    <div>
                      <h3 class="dark:text-darkblue-200 font-bold text-sm mb-2" >{{ $t('clients.api_keys.secret_plural') }}</h3>
                      <el-table ref="secrets" :data="form.ApiKeys" style="width: 100%" height="15rem" :empty-text="$t('app.no_data_text')">
                        <el-table-column prop="ApiKey" :label="$t('clients.api_keys.secret')" min-width="200"></el-table-column>
                        <el-table-column prop="ExpirationDate" :format="datePattern" :label="$t('clients.api_keys.expiration')" min-width="200"></el-table-column>
                        <el-table-column prop="actions" min-width="100" :label="$tc('app.actions', 2)">
                          <template slot-scope="scope">
                            <div class="flex flex-row">
                              <base-button-icon  name="editpencil" @click="editApiKeyHandler(scope.row)" size="md" icon-size="sm" mode="core" :loading="scope.row.loading" :disabled="scope.row.loading || isGeneralLoading"/>
                              <base-button-icon  name="trash" @click="deleteApiKeyHandler(scope.row)" size="md" icon-size="sm" mode="core" :loading="scope.row.loading" :disabled="scope.row.loading || isGeneralLoading"/>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                    <div class="flex justify-between w-full mt-4 px-2">
                        <base-button-responsive mode="primary" :text="$t('clients.api_keys.add_secret')" icon="plus" 
                          @click="addApiKey" :loading="isGeneralLoading" />
                        <base-button-responsive mode="primary" :text="$t('clients.user_service_submenu.disable_user')"
                          @click.prevent.stop="disableUserService" :loading="isGeneralLoading" />
                    </div>
                  </div>
                </div>
                <!-- #endregion -->

                <!-- #region Edición -->
                <div class="mb-4" v-if="(isServiceUserActive && isCreate) || (!isCreate && !form.UsuarioServicio && isServiceUserActive)">
                  <div v-if="!this.form.generateApiKey || role !== 3" class="mb-4" >
                    <base-password-form-item v-model="form.servicePassword" autocomplete="new-password" name="servicePassword" />
                    <base-password-form-item v-model="form.serviceRepeatPassword" :password="form.servicePassword" autocomplete="new-password" name="serviceRepeatPassword" repeat />
                  </div>
                </div>
                <!-- #endregion -->
              </template>
            </base-collapsible-form>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isCreate ? $t('app.cancel') : $t('app.back')" icon="cross"
            @click="goBack" :loading="isGeneralLoading" />
          <base-button-responsive v-if="!isCreate" mode="primary" :text="$t('app.goto_users')" icon="user"
            @click="goToUsers" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="!isCreate" mode="primary" :text="$t('app.goto_groups')" icon="group" @click="goToGroups" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="!isCreate" mode="primary" :text="$t('app.goto_companies')" icon="company"
            @click="goToCompanies" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="!isCreate" mode="primary" :text="$t('app.goto_certificates')" icon="certificates"
            @click="goToCertificates" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive
            v-if="form.idTipoProvisionamiento === 1 && !form.FechaFacturacion && !isCreate && !form.activo" mode="primary"
            :text="$t('clients.send_facturacion')" icon="mailsend" @click="submitForm('ruleForm', true)"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </template>
      </base-footer>
      <input-create-metadata-dialog
        :dialogOpen="showModalMetadato" 
        @toggleDialog="newMetadatoToggleDialog" 
        @applyDialog="applyNewMetadatoDialog"
        :header="$t('invoices.metadatos.new_metadato_long')" 
        />
      <input-modify-metadata-dialog
        :dialogOpen="showModalAddListMetadata" 
        @toggleDialog="addValueToListMetadataToggleDialog" 
        @applyDialog="applyModifyMetadatoDialog"
        :header="$t('invoices.metadatos.modify_values')" 
        :campoMetadato="actualMetadataSelected"
        :tipoMetadato="actualTypeSelectedNumber"
        :idCliente="id"
        />
      <service-generate-password-dialog :dialogOpen="showModifyServicePassword"
        :idCliente="id" @toggleDialog="toggleDialogs" />
      <service-generate-apikey-dialog :dialogOpen="showGeneratedApiKey" :apiKey="APIKeyGenerated" @toggleDialog="toggleAPIDialog"/>
      <service-delete-apikey-dialog :dialogOpen="showDeleteApiKey" @toggleDialog="toggleDeleteDialog" @applyDialog="deleteApiKey" />
      <service-edit-apikey-dialog :dialogOpen="showEditApiKey" :row="toEditApiKey" @toggleDialog="toggleEditDialog" @applyDialog="editApiKey" />
    </template>
  </detail-layout>
</template>

<script>
import { i18n } from '@/i18n'
import moment from 'moment'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { newClient } from '@/services/clients/newClient'
import { addApiKeyServiceUser } from '@/services/clients/addApiKeyServiceUser'
import { deleteApiKeyServiceUser } from '@/services/clients/deleteApiKeyServiceUser'
import { updateApiKeyServiceUser } from '@/services/clients/updateApiKeyServiceUser'
import { newServiceUser } from '@/services/clients/newServiceUser'
import { getClient } from '@/services/clients/getClient'
import { getStoredDataDocs } from '@/services/clients/getStoredDataDocs'
import { getDistributors } from '@/services/distributors/getDistributors'
import { sendFacturacion } from '@/services/clients/sendFacturacion'
import { updateClient } from '@/services/clients/updateClient'
import { disableServiceUser } from '@/services/clients/disableServiceUser'
import { getPartners } from '@/services/clients/getPartners'
import { getClients } from '@/services/clients/getClients'
import { newUser } from '@/services/configurations/newUser'
import { email as emailRegex } from '@/utils/regex'

import ServiceGeneratePasswordDialog from '@/components/ServiceGeneratePasswordDialog.vue'
import ServiceGenerateApikeyDialog from '@/components/ServiceGenerateApikeyDialog.vue'
import ServiceDeleteApikeyDialog from '@/components/ServiceDeleteApikeyDialog.vue'
import ServiceEditApikeyDialog from '@/components/ServiceEditApikeyDialog.vue'

import { newListMetadatas } from '@/services/clients/lists/newListMetadatas'
import { updateNameMetadata } from '@/services/clients/lists/updateNameMetadata' 
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { deleteListMetadatas } from '@/services/clients/lists/deleteListMetadatas'
import InputCreateMetadataDialog from '@/components/InputCreateMetadataDialog.vue'
import InputModifyMetadataDialog from '@/components/InputModifyMetadataDialog.vue'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'

function isValidNumber (value, maxlength) {
  if (Number.isInteger(parseFloat(value))) {
    const max = maxlength > 0 ? Number('9'.repeat(maxlength)) : 0
    if (value >= 0 && value <= max) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'client-detail',
  components: {
    DetailLayout,
    ServiceGeneratePasswordDialog,
    ServiceGenerateApikeyDialog,
    ServiceDeleteApikeyDialog,
    ServiceEditApikeyDialog,
    InputCreateMetadataDialog,
    InputModifyMetadataDialog,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      showModifyServicePassword: false,
      showGeneratedApiKey: false,
      showGeneratePassword: false,
      showDeleteApiKey: false,
      showEditApiKey: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      loadingDistribuidores: false,
      loadingPartners: false,
      loadingGruposCliente: false,
      distribuidores: [],
      partners: [],
      gruposCliente: [],
      APIKeyGenerated: '',
      toDeleteApiKey: null,
      toEditApiKey: null,
      showModalMetadato: false,
      showModalAddListMetadata: false,
      actualMetadataSelected: '',
      actualTypeSelected: 0,
      header: {
        title: i18n.t('clients.header_long'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/clients'
      },
      almacenamientoInvoiceOcupado: 0,
      almacenamientoInvoiceTotal: 0,
      form: this.getDefaultForm(),
      tooltipVerTodoStatuses: i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: i18n.t('tooltip.ver_todo_companies'),
      tooltipLocalAuth: i18n.t('tooltip.client.only_for_local_auth'),
      validation: {
        NumInvoicesTotal: 9,
        NumVolumenTotal: 12,
        StoredSpaceTotal: 7,
        NumCompaniesTotal: 4,
        NumUsersTotal: 4,
        MaxCharEmailProvider: 60,
      },
      updateRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        codigoExterno: [
          { validator: this.isCodigoExternoValid, trigger: 'change' }
        ],
        mesesUserPass: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        grupoClienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        FechaAlta: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        StoredSpaceTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumInvoicesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumVolumenTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumCompaniesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsersTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        EmailAutofacturaDefecto: [
          { validator: this.isOptionalEmailValid, trigger: 'blur' }
        ],
      },
      newRules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        codigoExterno: [
          { validator: this.isCodigoExternoValid, trigger: 'change' }
        ],
        username: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        idioma: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change']
          }
        ],
        ns: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        partnerId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        grupoClienteId: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        tipoAuth: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        mesesUserPass: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        StoredSpaceTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumInvoicesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumVolumenTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumCompaniesTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsersTotal: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    actualTypeSelectedNumber () {
      return this.actualTypeSelected === i18n.t('tipos.metadato.self_feeding_list') ? 1
        : this.actualTypeSelected === i18n.t('tipos.metadato.non_self_feeding_list') ? 2
          : 0
    },
    percentageNumClients: function () {
      if (this.form.NumClients === 0 || this.form.NumClientsTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumClients) * 100) / parseInt(this.form.NumClientsTotalProgres)) 
    },
    percentageStoredSpace: function () {
      if (this.form.StoredSpace === 0 || this.form.StoredSpaceTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.StoredSpace) * 100) / parseInt(this.form.StoredSpaceTotalProgres)) 
    },
    percentageNumInvoices: function () {
      if (this.form.NumInvoices === 0 || this.form.NumInvoicesTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumInvoices) * 100) / parseInt(this.form.NumInvoicesTotalProgres)) 
    },
    percentageNumVolumen: function () {
      if (this.form.NumVolumen === 0 || this.form.NumVolumenTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumVolumen) * 100) / parseInt(this.form.NumVolumenTotalProgres)) 
    },
    percentageNumCompanies: function () {
      if (this.form.NumCompanies === 0 || this.form.NumCompaniesTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumCompanies) * 100) / parseInt(this.form.NumCompaniesTotalProgres)) 
    },
    percentageNumUsers: function () {
      if (this.form.NumUsers === 0 || this.form.NumUsersTotalProgres === 0) return 0
      return Math.round((parseInt(this.form.NumUsers) * 100) / parseInt(this.form.NumUsersTotalProgres)) 
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasAutofactura: function () {
      return !!this.$store.getters['auth/hasAutofacturaModule']
    },
    hasApprobationFlow: function () {
      return !!this.$store.getters['auth/hasAprobationFlowModule']
    },
    hasAADIntegration: function () {
      return !!this.$store.getters['auth/hasIntegracionAADModule']
    },
    hasSAML2Integration: function () {
      return !!this.$store.getters['auth/hasSAML2Module']
    },
    disableActiveLibre () {
      return this.isCreate && this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    },
    disableTipoLibre () {
      return (
        ((this.role === 8 || this.role === 7) && this.form?.idTipoProvisionamiento === 1) ||
        this.disableActiveLibre
      )
    },
    disableLicenciamiento () {
      return (this.form.activo || this.form.FechaFacturacion) &&
        !this.isCreate && 
        this.role !== 3 && 
        this.form.idTipoProvisionamiento === 1
    },
    serviceUserName: function () {
      return 'GestionFacturas' + this.form.ns
    },
    isServiceUserActive: function () {
      return this.form?.serviceUser
    },
    tiposAuthFiltered: function () {
      var arrayAuthTypes = this.$store.getters['config/TIPOS_AUTH']
      if (!this.hasAADIntegration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['AAD', 'Mixto'].includes(x.key))
      }
      if (!this.hasSAML2Integration) {
        arrayAuthTypes = arrayAuthTypes.filter(x => !['SAML2', 'MixtoSAML2'].includes(x.key))
      }
      return arrayAuthTypes
    },
    mesesUserPassCaduc: function () {
      return this.$store.getters['config/MESES_USER_PASS_CADUC']
    },
    tiposServicio: function () {
      // Hay duplicados
      const tipos = new Set(this.$store.getters['config/TIPOS_SERVICIO'].map(JSON.stringify))
      return Array.from(tipos).map(JSON.parse)
    },
    tiposMetadato: function () {
      return this.$store.getters['config/TIPOS_METADATOS_CREACION']
    },
    tiposIdioma: function () {
      return this.$store.getters['config/TIPOS_IDIOMA']
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.idDistribuidor': function (value, oldValue) {
      this.refreshGrupoClientes()
    },
  },
  created: async function () {
    this.$store.commit('setIsLoading', true)
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 3 ? 'configurationssa' : 'configurations',
      name: i18n.t('configurations.header')
    })

    try {
      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataDistributors))
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: x.IdDistribuidor }))
        this.loadingDistribuidores = false

        this.loadingPartners = true
        const dataClients = await getPartners()
        if (dataClients.blnError === false) {
          this.partners = dataClients.Partners.map(x => ({ label: x.Descripcion, value: x.IdPartner }))
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
        }
        this.loadingPartners = false
        await this.refreshGrupoClientes()
      }
      if (this.disableActiveLibre) {
        this.form.activo = false
      }
    } catch (error) {
      this.doFeedback()
    }

    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({
        path: 'configurations/clients',
        name: i18n.t('clients.header')
      })
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
      this.downloadListMetada()
    } else {
      breadcrumbs.push({
        path: '',
        name: i18n.t('clients.new_client')
      })
      
      this.form.NumInvoicesTotal = 10000
      this.form.NumVolumenTotal = 1000000
      this.form.StoredSpaceTotal = 500
      this.form.NumCompaniesTotal = 10
      this.form.NumUsersTotal = 20

      this.form.NumInvoicesTotalProgres = 10000
      this.form.NumVolumenTotalProgres = 1000000
      this.form.StoredSpaceTotalProgres = 500
      this.form.NumCompaniesTotalProgres = 10
      this.form.NumUsersTotalProgres = 20

      this.setClient({ idDistribuidor: this.$store.getters['auth/user'].idDistribuidor })
      this.$store.commit('setIsLoading', false)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.$refs.baseCollapsibleConfigGeneral.toggle()
    if (this.isCreate) {
      this.form.idioma = 'es'
      this.$refs.baseCollapsibleLicenciamiento.toggle()
      this.$refs.baseCollapsibleUsuarioServicio.toggle()
      this.$refs.baseCollapsibleFacturas.toggle()
      this.$refs.baseCollapsibleConfigUsers.toggle()
      this.$refs.baseCollapsibleConfigUserInitial.toggle()
    }
  },
  methods: {
    formatDate: function (strDate) {
      return i18n.d(strDate, 'numeric_date', { date: '-' })
    },
    newMetadatoToggleDialog () {
      this.showModalMetadato = !this.showModalMetadato
    },
    downloadListMetada: async function () {
      try {
        const payload = { idCliente: this.id ?? -1 }
        const result = await getListMetadatas(payload)
        if (result.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', result))
        } else {
          this.form.ListaBlancaMetadatos = result.Respuesta.map(x => ({ Nombre: x.Campo, EsLista: x.EsLista, Tipo: x.Tipo }))
          for (let i = 0; i < this.form.ListaBlancaMetadatos.length; i++) {
            this.form.ListaBlancaMetadatos[i].Tipo = this.tiposMetadato.find(x => x.id === this.form.ListaBlancaMetadatos[i].Tipo)?.name ?? this.form.ListaBlancaMetadatos[i].Tipo
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    applyNewMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: metadato.value, 
          Tipo: metadato.type,
          idCliente: this.id,
        }
        const response = await newListMetadatas(payload)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.newMetadatoToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyModifyMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        metadato.idCliente = this.id
        const response = await updateNameMetadata(metadato)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.addValueToListMetadataToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    addValueToListMetadataToggleDialog (scope) {
      this.actualMetadataSelected = scope?.row?.Nombre || ''
      this.actualTypeSelected = scope?.row?.Tipo || 0
      this.showModalAddListMetadata = !this.showModalAddListMetadata
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Campo: row.Nombre, idCliente: this.id }
        const response = await deleteListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    changeDistribuidor: function (value) {
      if (value) {
        const distribuidor = this.distribuidores.find(x => x.IdDistribuidor === value)
        if (distribuidor) {
          const partner = this.partners.find(x => x.Descripcion === distribuidor.Nombre)
          if (partner) {
            this.form.partnerId = partner.IdPartner
          } else {
            this.form.partnerId = String(distribuidor.Nombre)
          }
          return
        }
      }
      this.form.partnerId = 1
    },
    toggleDialogs: function () {
      this.showModifyServicePassword = !this.showModifyServicePassword
    },
    toggleAPIDialog: function () {
      this.showGeneratedApiKey = !this.showGeneratedApiKey
    },
    toggleDeleteDialog: function () {
      this.showDeleteApiKey = !this.showDeleteApiKey
    },
    toggleEditDialog: function () {
      this.showEditApiKey = !this.showEditApiKey
    },
    refreshGrupoClientes: async function () {
      this.loadingGruposCliente = true
      if (this.isCreate) this.form.grupoClienteId = ''
      this.gruposCliente = []
      const params = { grupoClientes: true }
      if (this.form.idDistribuidor) params.idDistribuidor = this.form.idDistribuidor
      const dataGruposCliente = await getClients(params)
      if (dataGruposCliente.blnError === false) {
        this.gruposCliente = dataGruposCliente.Clientes.map(x => ({ label: x.Nombre, value: x.idCliente }))
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataGruposCliente))
      }
      this.loadingGruposCliente = false
    },
    getDataParams: function () {
      const data = { filters: [] }
      data.filters.push({ type: 'cliente', data: { label: this.form.name, id: this.id || -1 } })
      return data
    },
    goToUsers: function () {
      const data = this.getDataParams()
      this.$router.push({ name: 'configurations/users', params: { data: data } })
    },
    goToGroups: function () {
      const data = this.getDataParams()
      this.$router.push({ name: 'configurations/groups', params: { data: data } })
    },
    goToCompanies: function () {
      const data = this.getDataParams()
      this.$router.push({ name: 'companies', params: { data: data } })
    },
    goToCertificates: function () {
      const data = this.getDataParams()
      this.$router.push({ name: 'certificates', params: { data: data } })
    },
    customColorMethod: function (percentage) {
      if (percentage >= 80) {
        return '#ff7c75'
      } else if (percentage >= 60) {
        return '#ffda9e'
      } else {
        return 'var(--primary-400)'
      }
    },
    isNumberValid: function (rule, value, callback) {
      if (value === undefined || value === null || value === '') {
        return callback(new Error(i18n.t('validation.complete')))
      } else if (value < 0) {
        callback(new Error(i18n.t('validation.num_positive')))
      } else if (!isValidNumber(value, this.validation[rule.field])) {
        callback(new Error(i18n.t('validation.num_max_custom', { max: this.validation[rule.field] })))
      } else {
        callback()
      }
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      this.isOptionalEmailValid(rule, value, callback)
    },
    isOptionalEmailValid: function (rule, value, callback) {
      if (value && !emailRegex.test(value)) {
        callback(new Error(i18n.tc('users.email', 1)))
      } else {
        callback()
      }
    },
    getDefaultForm: function () {
      return {
        name: '',
        codigoExterno: '',
        FechaAlta: null,
        ns: '',
        username: '',
        email: '',
        idioma: '',
        idDistribuidor: '',
        partnerId: '',
        password: '',
        repeat_password: '',
        tipoServicio: '',
        mesesUserPass: 0,
        grupoClienteId: '',
        verTodoStatuses: true,
        verTodoCompanies: true,
        tipoAuth: 0,
        StoredSpace: 0,
        NumInvoices: 0,
        NumVolumen: 0,
        NumCompanies: 0,
        NumUsers: 0,

        generateApiKey: false,

        NumInvoicesTotal: this.isCreate ? 10000 : 0,
        NumVolumenTotal: this.isCreate ? 1000000 : 0,
        StoredSpaceTotal: this.isCreate ? 500 : 0,
        NumCompaniesTotal: this.isCreate ? 10 : 0,
        NumUsersTotal: this.isCreate ? 20 : 0,

        NumInvoicesTotalProgres: this.isCreate ? 10000 : 0,
        NumVolumenTotalProgres: this.isCreate ? 1000000 : 0,
        StoredSpaceTotalProgres: this.isCreate ? 500 : 0,
        NumCompaniesTotalProgres: this.isCreate ? 10 : 0,
        NumUsersTotalProgres: this.isCreate ? 20 : 0,

        PagarAlContabilizar: false,
        
        GenerarUsuarioAuto: true,
        EnviarMailFactura: false,
        EmailAutofacturaDefecto: '',

        activo: true,
        FechaFacturacion: null,
        idTipoProvisionamiento: null,
        VincularUsuariosGrupoGestorInvoiZE: false,
        FlujoAprobacion: false,
        serviceUser: false,
        servicePassword: '',
        serviceRepeatPassword: '',

        UsuarioServicio: null,

        RequiereOTP: false,
        CambioPassPrimerAcceso: false,

        ListaBlancaMetadatos: [],

        ApiKeys: []
      }
    },
    watchFormHandler: function ({ certificate, send_alerts, partnerId }) { },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isCodigoExternoValid: function (rule, value, callback) {
      const re = /["<>|:*?\\/]/
      // if (!value) {
      //   return callback(new Error(i18n.t('validation.complete')))
      // } else {
      if (re.test(value)) {
        return callback(new Error(i18n.t('validation.codigo_ext.chars')))
      } else {
        callback()
      }
      // }
    },
    sendFacturacionHandler: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { idCliente: this.id }
        const response = await sendFacturacion(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.send_facturacion_msg'), 'success')
          this.form.FechaFacturacion = new Date()
        }
      } catch (error) {
        this.doFeedback()
      }
      this.$store.commit('setIsLoading', false)
    },
    submitForm: function (formName, sendFactura = false) {
      if (this.isCreate) {
        this.newClientHandler(formName)
      } else {
        this.updateClientHandler(formName, sendFactura)
      }
    },
    newClientHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            NumeroSerie: this.form.ns,
            Nombre: this.form.name,
            CodigoExterno: this.form.codigoExterno,
            idDistribuidor: this.form.idDistribuidor || null,
            idPartner: Number.isInteger(this.form.partnerId) ? this.form.partnerId : null,
            Partner: Number.isInteger(this.form.partnerId) ? null : this.form.partnerId,
            MesesUserPass: this.form.mesesUserPass,
            idGrupoCliente: this.form.grupoClienteId || null,
            NumeroCIFEmpresas: this.form.NumCompaniesTotal,
            NumeroUsuarios: this.form.NumUsersTotal,
            EspacioTotal: this.form.StoredSpaceTotal,
            NumFacturas: this.form.NumInvoicesTotal,
            NumVolumen: this.form.NumVolumenTotal,
            PagarAlContabilizar: this.form.PagarAlContabilizar,
            Activo: this.form.activo,
            VincularUsuariosGrupoGestorInvoiZE: this.form.VincularUsuariosGrupoGestorInvoiZE,


            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
          }
          const response = await newClient(payload)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            let isok = true
            // #region Create First User
            const primerUsuario = {
              Nombre: this.form.username,
              Email: this.form.email,
              Password: this.form.password,
              VerTodoEstados: this.form.verTodoStatuses,
              VerTodoEmpresas: this.form.verTodoCompanies,
              idTipoAutenticacion: this.form.tipoAuth,
              idRol: 2,
              idCliente: response.Respuesta,
              Idioma: this.form.idioma
            }
            if (!this.hasAADIntegration && !this.hasSAML2Integration) {
              primerUsuario.idTipoAutenticacion = this.tiposAuthFiltered.find(x => x.key === 'Local')?.value ?? 0
            }
            
            const responseFirstUser = await newUser(primerUsuario)
            if (responseFirstUser.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseFirstUser))
              isok = false
            }
            // #endregion
            if (this.form.serviceUser) {
              const payload = {
                idCliente: response.Respuesta, 
                PasswordServicio: this.form.servicePassword,
                GenerateApiKey: this.form.generateApiKey,
                ApiKeyExpireDate: null
              }
              const responseService = await newServiceUser(payload)
              if (responseService.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseService))
                isok = false
              } else {
                if (responseService.APIKey !== null) {
                  this.APIKeyGenerated = responseService.APIKey
                  this.toggleAPIDialog()
                }
                if (this.disableActiveLibre) {
                  this.form.activo = false
                }
              }
            }

            if (isok) {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              this.resetForm()
              this.form = this.getDefaultForm()
            }
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    updateClientHandler: async function (formName, sendFactura = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            idCliente: 0,
            NumeroSerie: '',
            Nombre: this.form.name,
            CodigoExterno: this.form.codigoExterno,
            FechaAlta: this.form.FechaAlta,
            idPartner: 0,
            MesesUserPass: this.form.mesesUserPass,
            NumeroCIFEmpresas: this.disableLicenciamiento ? null : this.form.NumCompaniesTotal,
            NumeroUsuarios: this.disableLicenciamiento ? null : this.form.NumUsersTotal,
            EspacioTotal: this.disableLicenciamiento ? null : this.form.StoredSpaceTotal,
            NumFacturas: this.disableLicenciamiento ? null : this.form.NumInvoicesTotal,
            NumVolumen: this.disableLicenciamiento ? null : this.form.NumVolumenTotal,
            PagarAlContabilizar: this.form.PagarAlContabilizar,
            Activo: this.disableTipoLibre ? null : this.form.activo,
            VincularUsuariosGrupoGestorInvoiZE: this.form.VincularUsuariosGrupoGestorInvoiZE,
            FlujoAprobacion: this.form.FlujoAprobacion,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
            GenerarUsuarioProveedor: this.form.GenerarUsuarioAuto,
            EmailDefectoAutofactura: this.form.EmailAutofacturaDefecto,
            EnviarMailFactura: this.form.EnviarMailFactura,
          }
          const response = await updateClient({ idCliente: this.$route.params.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            if (this.form.serviceUser) {
              const payload = {
                idCliente: this.$route.params.id,
                PasswordServicio: this.form.servicePassword,
                GenerateApiKey: this.form.generateApiKey,
                ApiKeyExpireDate: null
              }
              const responseService = await newServiceUser(payload)
              if (responseService.blnError) {
                this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseService))
              } else {
                this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
                this.form.UsuarioServicio = this.serviceUserName
                this.updateView()
                this.$store.commit('app/setheaderBreadCrumb', this.form.name)
                if (sendFactura) {
                  await this.sendFacturacionHandler()
                }
                await this.downloadLicense()
                if (responseService.APIKey !== null) {
                  this.APIKeyGenerated = responseService.APIKey
                  this.toggleAPIDialog()
                }
              }
            } else {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
              this.updateView()
              this.$store.commit('app/setheaderBreadCrumb', this.form.name)
              if (sendFactura) {
                await this.sendFacturacionHandler()
              }
              await this.downloadLicense()
            }
          }
        } else {
          this.$message({
            type: 'error',
            message: i18n.t('feedback.error.process_data_error')
          })
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    disableUserService: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await disableServiceUser({ idCliente: this.$route.params.id })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.user_service_disabled_msg'), 'success')
          this.form.UsuarioServicio = null
        }
      } catch (error) {
        this.doFeedback()
      }
      this.$store.commit('setIsLoading', false)
    },
    resetForm: function () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/clients' })
    },
    downloadData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: id
        }
        client = await getClient(params)
        this.setClient(client.Cliente)
        // Datos Almacenamiento
        await this.downloadLicense()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    downloadLicense: async function () {
      if (!this.id) return
      const params = { idCliente: this.id }
      try {
        const response = await getStoredDataDocs(params)
        if (response.blnError === false) {
          const dataAlmacenamiento = response.respuesta
          this.form.NumCompanies = dataAlmacenamiento?.EmpresasActuales ?? 0
          this.form.NumUsers = dataAlmacenamiento?.UsuariosActuales ?? 0
          this.form.StoredSpace = dataAlmacenamiento?.AlmacenamientoOcupado ?? 0
          this.form.NumInvoices = dataAlmacenamiento?.NumFacturasOcupado ?? 0
          this.form.NumVolumen = dataAlmacenamiento?.NumVolumenOcupado ?? 0

          this.form.NumCompaniesTotalProgres = dataAlmacenamiento?.EmpresasPermitidos ?? 0
          this.form.NumUsersTotalProgres = dataAlmacenamiento?.UsuariosPermitidos ?? 0
          this.form.StoredSpaceTotalProgres = dataAlmacenamiento?.AlmacenamientoMaximo ?? 0
          this.form.NumInvoicesTotalProgres = dataAlmacenamiento?.NumFacturasMaximo ?? 0
          this.form.NumVolumenTotalProgres = dataAlmacenamiento?.NumVolumenMaximo ?? 0
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    setClient: function (cliente) {
      this.form.name = cliente.Nombre
      this.form.codigoExterno = cliente.CodigoExterno
      this.form.FechaAlta = cliente.FechaAlta
      this.form.ns = cliente.NumeroSerie
      if (!cliente.idDistribuidor) {
        this.distribuidores.unshift({ value: 0, label: 'ZeroComa' })
        this.form.idDistribuidor = 0
      } else {
        this.form.idDistribuidor = cliente.idDistribuidor
      }
      if (cliente.idPartner === null) {
        this.partners.unshift({ value: 0, label: i18n.t('app.non_partner') })
        this.form.partnerId = 0
      } else {
        this.form.partnerId = cliente.idPartner || ''
      }
      if (cliente.idGrupoCliente === null || cliente.idGrupoCliente === '') {
        this.gruposCliente.unshift({ value: 0, label: i18n.t('app.none') })
        this.form.grupoClienteId = 0
      } else {
        this.form.grupoClienteId = cliente.idGrupoCliente || ''
      }
      if (cliente.idTipoServicio === undefined || cliente.idTipoServicio === null) {
        this.form.tipoServicio = 0
      } else {
        this.form.tipoServicio = cliente.idTipoServicio || ''
      }
      this.form.mesesUserPass = cliente.MesesUserPass || 0
      
      if (!this.isCreate) {
        this.form.NumCompanies = cliente.NumeroCIFEmpresasActuales || 0
        this.form.NumUsers = cliente.UsuariosActuales || 0
        this.form.StoredSpace = cliente.EspacioActual || 0
        this.form.NumInvoices = cliente.NumFacturasActual || 0
        this.form.NumVolumen = cliente.NumVolumenActual || 0

        this.form.NumCompaniesTotal = cliente.NumeroCIFEmpresas || 0
        this.form.NumUsersTotal = cliente.NumeroUsuarios || 0
        this.form.StoredSpaceTotal = cliente.EspacioTotal || 0
        this.form.NumInvoicesTotal = cliente.NumFacturas || 0
        this.form.NumVolumenTotal = cliente.NumVolumen || 0

        this.form.NumCompaniesTotalProgres = cliente.NumeroCIFEmpresas || 0
        this.form.NumUsersTotalProgres = cliente.NumeroUsuarios || 0
        this.form.StoredSpaceTotalProgres = cliente.EspacioTotal || 0
        this.form.NumInvoicesTotalProgres = cliente.NumFacturas || 0
        this.form.NumVolumenTotalProgres = cliente.NumVolumen || 0
      }

      this.form.GenerarUsuarioAuto = cliente.GenerarUsuarioProveedor
      this.form.EmailAutofacturaDefecto = cliente.EmailDefectoAutofactura
      this.form.EnviarMailFactura = cliente.EnviarMailFactura

      this.form.PagarAlContabilizar = !!cliente.PagarAlContabilizar
      this.form.activo = !!cliente.Activo
      this.form.FechaFacturacion = cliente.FechaFacturacion
      this.form.VincularUsuariosGrupoGestorInvoiZE = !!(cliente.VincularUsuariosGrupoGestorInvoiZE || this.isCreate)

      this.form.CambioPassPrimerAcceso = !!cliente.CambioPassPrimerAcceso
      this.form.RequiereOTP = !!cliente.RequiereOTP
      this.form.FlujoAprobacion = !!cliente.FlujoAprobacion
      this.form.UsuarioServicio = cliente.UsuarioServicio || ''
      this.form.idTipoProvisionamiento = cliente.idTipoProvisionamiento

      if (cliente.ApiKeys?.length) {
        const formApiKeys = cliente.ApiKeys
        formApiKeys.forEach(apiKey => {
          apiKey.NoFormatDate = moment(apiKey.ExpirationDate).format('yyyy-MM-DD[T00:00:00]')
          apiKey.ExpirationDate = this.formatDate(apiKey.ExpirationDate)
        })
        this.form.ApiKeys = formApiKeys
      }
    },
    generatePassword: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    addApiKey: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const responseKey = await addApiKeyServiceUser({ idCliente: this.id, ApiKeyExpireDate: null })
        if (responseKey.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', responseKey))
        } else {
          this.APIKeyGenerated = responseKey.APIKey
          if (responseKey.idAPIKey !== undefined) {
            const generatedApiKey = {
              idApiKey: responseKey.idAPIKey,
              ApiKey: responseKey.APIKeyTruncated,
              ExpirationDate: this.formatDate(responseKey.ExpirationDate),
              NoFormatDate: moment(responseKey.ExpirationDate).format('yyyy-MM-DD[T00:00:00]') 
            }
            this.form.ApiKeys.unshift(generatedApiKey)
          }
          this.toggleAPIDialog()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteApiKey: async function () {
      this.$store.commit('setIsLoading', true)
      if (this.toDeleteApiKey !== null) {
        try {
          const payload = {
            idAPIKey: this.toDeleteApiKey.idApiKey,
            idCliente: this.id
          }
          const response = await deleteApiKeyServiceUser(payload)

          if (response.blnError) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('clients.api_keys.delete_secret_ok'), 'success')
            this.form.ApiKeys = this.form.ApiKeys.filter(x => x.idApiKey !== this.toDeleteApiKey.idApiKey) // Actualizamos tabla secretos
          }
        } catch (error) {
          // console.log('CustomLog: error', error)
          this.doFeedback(error)
        } finally {
          this.$store.commit('setIsLoading', false)
        }
      }
    },
    deleteApiKeyHandler: function (row) {
      if (Object.hasOwnProperty.call(row, 'idApiKey')) {
        this.toDeleteApiKey = row
        this.toggleDeleteDialog()
      }
    },
    editApiKeyHandler: function (row) {
      if (Object.hasOwnProperty.call(row, 'idApiKey')) {
        this.toEditApiKey = row
        this.toggleEditDialog()
      }
    },
    editApiKey: async function (row, date) {
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idAPIKey: row.idApiKey,
          idCliente: this.id,
          ApiKeyExpireDate: date,
        }
        const response = await updateApiKeyServiceUser(payload)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('clients.api_keys.update_secret_ok'), 'success')

          const updateEditeRow = this.form.ApiKeys.find(x => x.idApiKey === row.idApiKey)
          updateEditeRow.ExpirationDate = this.formatDate(date) 
          updateEditeRow.NoFormatDate = date
        }
      } catch (error) {
        this.doFeedback(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic > img {
  max-width: 100%;
  max-height: 100%;
}

.hideHScroll {
  overflow-x: hidden;
}
</style>

